import React from 'react';
import { Fill } from '../utils/fill';
import { colors, typography } from '../../theme';
import { FillControl } from './fill-control';

type Props = {
  fill: Fill;
  width: number;
  onPreviewFill: (v: Fill) => void;
  onCommitFill: (v: Fill) => void;
  onPreviewWidth: (w: number) => void;
  onCommitWidth: () => void;
  maxWidth?: number;
};

const labelStyle: React.CSSProperties = {
  fontSize: typography.fontSize.base,
  fontFamily: typography.fontFamily.ui,
  color: colors.textMuted,
  flexShrink: 0
};

const valueStyle: React.CSSProperties = {
  fontSize: typography.fontSize.base,
  fontFamily: typography.fontFamily.ui,
  color: colors.textSecondary,
  minWidth: '28px'
};

export const StrokeControls: React.FC<Props> = ({
  fill,
  width,
  onPreviewFill,
  onCommitFill,
  onPreviewWidth,
  onCommitWidth,
  maxWidth = 10
}) => (
  <>
    <FillControl value={fill} onPreview={onPreviewFill} onCommit={onCommitFill} label='Borde' />
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span style={labelStyle}>Grosor</span>
      <input
        type='range'
        min={0}
        max={maxWidth}
        step={1}
        value={width}
        onChange={e => onPreviewWidth(Number(e.target.value))}
        onPointerUp={onCommitWidth}
        style={{ width: 80, cursor: 'pointer' }}
      />
      <span style={valueStyle}>{width.toFixed(0)}px</span>
    </div>
  </>
);
